import { getCsrfToken } from "../auth/authApi";
import { apiFetch } from "../../shared/http/apiFetch";
import type { SubcontractingSnapshot } from "./types";
const base = "/api/v1/subcontracting";
export async function getSubcontracting() {
  const r = await apiFetch(base, { credentials: "include" });
  if (!r.ok) throw new Error("subcontracting.loadError");
  return r.json() as Promise<SubcontractingSnapshot>;
}
export async function subcontractingCommand(
  path: string,
  method: "POST" | "PUT",
  body: unknown,
) {
  const r = await apiFetch(base + path, {
    method,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": await getCsrfToken(),
    },
    body: JSON.stringify(body),
  });
  const p = (await r.json().catch(() => null)) as { code?: string; id?: string;
    planningScenarioRequired?: boolean } | null;
  if (!r.ok) throw new Error(p?.code ?? "subcontracting.actionError");
  if (p?.planningScenarioRequired)
    window.dispatchEvent(new CustomEvent('apl:planning-scenario-required'));
  return p;
}
